import React, { useEffect, useState } from "react";
import "./style.scss";
import "font-awesome/css/font-awesome.min.css";
import { image } from "../../../Assets";
import { useLocation } from "react-router-dom";
import { gsap } from "gsap";
import DropdownWhatwedo from "./DropdownWhatwedo";
import Dropdowncompany from "./Dropdowncompany";

const Header = () => {
  const [openMenu, setopenMenu] = useState(false);
  const [opensubMenu, setopensubMenu] = useState(false);
  const [opensubAboutMenu, setopensubAboutMenu] = useState(false);
  const [isDropdownOpen, setisDropdownOpen] = useState(false);

  const [Service, setService] = useState("BIM/VDC Services");
  const [Subservice, setSubservice] = useState("Visualization");
  const location = useLocation();

  useEffect(() => {
    ServicesList.map((obj) => {
      if (
        location.pathname.includes("modeling") ||
        location.pathname.includes("visualisation") ||
        location.pathname.includes("BIM")
      ) {
        {
          setService("BIM/VDC Services");
        }
        {
          obj.subService.map((obj2) => {
            if (location.pathname.includes("modeling")) {
              setSubservice("Modeling");
            } else if (location.pathname.includes("visualisation")) {
              setSubservice("Visualization");
            } else if (location.pathname.includes("BIM")) {
              setSubservice("BIM Management");
            }
          });
        }
      } else if (
        location.pathname.includes("shop-drawing-creation") ||
        location.pathname.includes("2D-overlay") ||
        location.pathname.includes("RFI-order-date-in-PM-software")
      ) {
        setService("Project Engineering Services");
      } else {
      }
    });

    if (location.pathname !== "/") {
      const header = document.querySelector("header");
      if (header) {
        header.classList.add("greenheader");
      }
    }
  }, [location.pathname]);

  const MouseIn = (e) => {
    e.preventDefault();
  };
  const MouseOut = (e) => {
    e.preventDefault();
  };

  const ServicesList = [
    {
      id: 1,
      ServiceName: "BIM/VDC Services",
      subService: [
        {
          id: 1,
          name: "Visualization",
          hasservice: true,
          subsubservices: [
            {
              id: 1,
              name: "2D/3D Rendering",
              link: "/visualisation/2D&3D-rendering",
            },
            {
              id: 2,
              name: "3D Walkthroughs/ Flythrough",
              link: "/visualisation/3D-Walkthrough-Flythrough",
            },
            {
              id: 3,
              name: "4D Simulations",
              link: "/visualisation/4D-Simulations",
            },
          ],
        },
        {
          id: 2,
          name: "Modeling",
          hasservice: true,
          subsubservices: [
            {
              id: 1,
              name: "2D(CAD/PDF) To 3D Modeling",
              link: "/modeling/2D-to-3D-modeling",
            },
            {
              id: 2,
              name: "Supplemental Modeling",
              link: "/modeling/supplemental-modeling",
            },
            {
              id: 3,
              name: "Point Cloud to 3D Modeling",
              link: "/modeling/point-cloud-to-3D-modeling",
            },
          ],
        },
        {
          id: 3,
          name: "BIM Management",
          hasservice: true,
          subsubservices: [
            {
              id: 1,
              name: "Clash Detection and Coordination",
              link: "/BIM-Management/clash-detection-and-coordination",
            },
            {
              id: 2,
              name: "BIM Execution Planning",
              link: "/BIM-Management/BIM-execution-planning",
            },
          ],
        },
      ],
    },
    {
      id: 2,
      ServiceName: "Project Engineering Services",
      hasservice: true,
      subService: [
        {
          id: 1,
          name: "Shop Drawing Creation",
          link: "/shop-drawing-creation",
        },
        {
          id: 2,
          name: "2D Overlay",
          link: "/2D-overlay",
        },
        {
          id: 3,
          name: "Document Management for RFIs, Submittals, and Change Orders",
          link: "/RFI-order-date-in-PM-software",
        },
      ],
    },
  ];

  const mobileseerviceslist = [
    {
      id: 1,
      name: "2D/3D Rendering",
      link: "/visualisation/2D&3D-rendering",
    },
    {
      id: 2,
      name: "3D Walkthroughs/ Flythrough",
      link: "/visualisation/3D-Walkthrough-Flythrough",
    },
    {
      id: 3,
      name: "4D Simulations",
      link: "/visualisation/4D-Simulations",
    },
    {
      id: 4,
      name: "2D(CAD/PDF) To 3D Modeling",
      link: "/modeling/2D-to-3D-modeling",
    },
    {
      id: 5,
      name: "Supplemental 3D Modeling",
      link: "/modeling/supplemental-modeling",
    },
    {
      id: 6,
      name: "Point Cloud to 3D Modeling",
      link: "/modeling/point-cloud-to-3D-modeling",
    },
    {
      id: 7,
      name: "Clash Detection and Coordination",
      link: "/modeling/clash-detection-and-coordination",
    },
    {
      id: 8,
      name: "BIM Execution Planning",
      link: "/modeling/BIM-execution-planning",
    },
    {
      id: 9,
      name: "Shop Drawing Creation",
      link: "/shop-drawing-creation",
    },
    {
      id: 10,
      name: "2D Overlay",
      link: "/2D-overlay",
    },
    {
      id: 11,
      name: "Document Management for RFIs, Submittals, and Change Orders",
      link: "/RFI-order-date-in-PM-software",
    },
  ];


  return (
    <>
      <header>
        <div className="container mainbar">
          <div className="row">
            <div className="col-3">
              <a href="/">
                <img src={image.logo} alt="" id="logo" />
              </a>
            </div>
            <div className="col-7 d-flex align-items-center justify-content-center">
              <div className="menu">
                <ul>
                  <li
                    className="page-link"
                    style={{  width:"100px", textAlign: "center" }}
                  >
                    <a href="/">Home</a>
                  </li> 
                  <li
                    className="page-link"
                    style={{ width:"100px",  textAlign: "center" }}
                  >
                    <a href="/">About</a>
                  </li>
                  <li
                    className="page-link"
                    style={{  width:"100px", textAlign: "center" }}
                  >
                    <a href="/">Industries</a>
                  </li>
                  <li
                    className="page-link"
                    style={{  width:"100px", textAlign: "center" }}
                  >
                    <a href="/">Services</a>
                  </li>  
                  <li
                    className="page-link"
                    style={{  width:"100px", textAlign: "center" }}
                  >
                    <a href="/">Resources</a>
                  </li>              
                  
                </ul>
              </div>
            </div>
            <div className="col-2 d-flex align-items-center justify-content-end">
              <div className="contact-btn">
                <a href="#contactform">Contact</a>
              </div>
            </div>
          </div>
        </div>
        <div className="container mobilemainbar">
          <div className="row">
            <div className="col-6">
              <a href="/">
                <img src={image.logo} alt="" />
              </a>
            </div>
            <div className="col-6 d-flex align-items-center justify-content-end">
              <button
                className="menubtn"
                onClick={() => setopenMenu(!openMenu)}
              >
                {/* <div className="bar1"></div>
                            <div className="bar2"></div>
                            <div className="bar3"></div> */}
                <svg
                  width="54"
                  height="29"
                  viewBox="0 0 54 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.9505 28.5L0.838044 0.5H38.0495L53.162 28.5H15.9505Z"
                    fill="#157438"
                    stroke="white"
                  />
                  <path d="M8 7H38.8148L40 9H9.18519L8 7Z" fill="white" />
                  <path d="M25 13H40.814L42 15H26.186L25 13Z" fill="white" />
                  <path d="M23 19H43.8421L45 21H24.1579L23 19Z" fill="white" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>
      <div className="mobilemenu" style={{ left: openMenu ? "0%" : "-100%" }}>
        <ul>
          <li className="page-link">
            <a href="/">Home</a>
          </li>
          <li className="page-link">
            <a href="/about">About</a>
          </li>
          <li className="page-link">
            <a href="/team">Team</a>
          </li>
          <li
            className="page-link d-flex align-items-center "
            onClick={() => setisDropdownOpen(!isDropdownOpen)}
          >
            Services{" "}
            {isDropdownOpen ? (
              <span className="arrow-down"></span>
            ) : (
              <span className="arrow-up"></span>
            )}
          </li>
          {isDropdownOpen ? (
            <ul className="dropdown" style={{padding:'0 10px'}}>
              {mobileseerviceslist.map((services, index) => (
                <li key={index}>
                  <a href={services.link} style={{color:'#000',textDecoration:'none'}}>
                    {services.name}
                  </a></li>
              ))}
            </ul>
          ) : (
            ""
          )}
          <li className="page-link">
            <a href="#contact">Contact</a>
          </li>
        </ul>

        <svg
          onClick={() => setopenMenu(!openMenu)}
          id="closebtn"
          width="40"
          height="40"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.93823 15.3547L15.3546 1.93825"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M2.64539 1.93825L16.0618 15.3547"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </>
  );
};

export default Header;
